import { Link } from 'react-router-dom';
import { BackArrowIcon } from '../components/BackArrowIcon';

/**
 * Auth entry — matches mobile `LandingScreen`: Get Started (sign up) + Sign In (credentials).
 */
export function AuthWelcomePage() {
  return (
    <div className="flex min-h-screen flex-col bg-white px-5 pb-10 pt-8">
      <Link
        to="/"
        className="inline-flex items-center gap-1.5 self-start text-sm font-medium text-slate-500 hover:text-slate-700"
      >
        <BackArrowIcon />
        Back
      </Link>

      <div className="flex flex-1 flex-col items-center justify-center px-2">
        <div className="mb-8 flex h-28 w-28 items-center justify-center overflow-hidden rounded-[28px] bg-white shadow-lg shadow-black/10">
          <img
            src="/bidmaster-icon.png"
            alt=""
            width={96}
            height={96}
            className="h-24 w-24 rounded-[20px] object-contain"
            decoding="async"
          />
        </div>
        <h1 className="mb-4 text-center text-4xl font-black tracking-tight text-slate-900">BidMaster</h1>
        <p className="max-w-[280px] text-center text-lg leading-relaxed text-slate-500">
          The real-time reverse bidding platform for next-gen procurement.
        </p>
      </div>

      <div className="mx-auto w-full max-w-[280px] shrink-0 space-y-4">
        <Link
          to="/signup"
          className="block w-full rounded-2xl bg-blue-600 py-5 text-center text-lg font-black text-white shadow-lg shadow-blue-600/30 transition-opacity hover:opacity-95 active:opacity-90"
        >
          Get Started
        </Link>
        <Link
          to="/signin/login"
          className="block w-full rounded-2xl border-2 border-indigo-100 bg-white py-5 text-center text-lg font-black text-blue-600 transition-colors hover:bg-slate-50"
        >
          Sign In
        </Link>
      </div>
    </div>
  );
}
